import React from 'react';
import type { MessageDescriptor } from 'react-intl-next';
import { FormattedMessage } from 'react-intl-next';

import Image from '@atlaskit/image';
import { Box, Inline, Stack, xcss } from '@atlaskit/primitives';

import { Link } from '@confluence/route-manager';

const imgStyle = xcss({
	width: '40px',
	paddingTop: 'space.050',
});

const titleTextStyle = xcss({
	fontSize: 14,
	fontStyle: 'normal',
	fontWeight: 700,
});

const bodyTextStyle = xcss({
	fontSize: 14,
	fontStyle: 'normal',
	fontWeight: 400,
});

const linkTextStyle = xcss({
	color: 'color.link',
	fontSize: '14px',
});

export type ListItemProps = {
	key?: string;
	bodyText: MessageDescriptor;
	darkImg: string;
	img: string;
	title: MessageDescriptor;
	linkText: MessageDescriptor;
	link: string;
	onLinkClick?: () => void;
};

export const ListItem = ({
	key,
	img,
	darkImg,
	title,
	bodyText,
	linkText,
	link,
	onLinkClick,
}: ListItemProps) => {
	return (
		<Inline space="space.200">
			<Box xcss={imgStyle}>
				<Image src={img} srcDark={darkImg} alt={`${key} icon`} css={{ minWidth: '40px' }} />
			</Box>
			<Stack space="space.050">
				<Box xcss={titleTextStyle}>
					<FormattedMessage {...title} />
				</Box>
				<Box xcss={bodyTextStyle}>
					<FormattedMessage {...bodyText} />
				</Box>
				<Box xcss={linkTextStyle}>
					<Link target="_blank" href={link} onClick={onLinkClick}>
						<FormattedMessage {...linkText} />
					</Link>
				</Box>
			</Stack>
		</Inline>
	);
};
